import { logisticsApi } from "./ApiClient";
import {
  getActivityCategoryConfig,
  type IActivityCategory,
} from "@medoma/models/activities";

type ISaveActivityInvoicingCode = {
  activityId: string;
  patientId: string;
  procedureCodes: string[];
  productCodes: string[];
};

export const saveActivityInvoicingCodes = async ({
  activityId,
  patientId,
  procedureCodes,
  productCodes,
}: ISaveActivityInvoicingCode) => {
  await logisticsApi.post(`/invoicing/activities/${activityId}`, {
    json: { patientId, procedureCodes, productCodes },
  });
};

export const shouldSaveInvoice = ({
  invoicingActivated,
  category,
  procedureCodes,
  productCodes,
  activityHasPatient,
}: {
  invoicingActivated: boolean;
  category: IActivityCategory;
  procedureCodes: string[];
  productCodes: string[];
  activityHasPatient: boolean;
}) => {
  const { allowsInvoicingCode } = getActivityCategoryConfig({
    category,
    activityHasPatient,
  });

  return (
    invoicingActivated &&
    allowsInvoicingCode &&
    (procedureCodes.length > 0 || productCodes.length > 0)
  );
};
